<template>
  <nav class="navbar navbar-dark navbar-expand-lg bg-body-tertiary fixed-navbar " style="overflow:hidden; display: inline-block!important; min-height: 59px; padding-left: 2%!important; padding-right: 2%!important; margin: 0 auto; background-color: #2D2D2DFF!important;">
    <div class="container-fluid px-0">
      <div class="container ms-0 me-auto px-0" style=" width: auto; background-color: #2D2D2DFF!important;">
        <a class="navbar-brand" style="margin: 0" href="/">
          <img src="/assets/logo_addgrill_with_text.svg" style="height: auto;!important; " alt="AddGrill">
        </a>
      </div>
      <button class="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
              id="toggler_navbar"
              style="margin-right: 2%!important;"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse " id="navbarSupportedContent">
        <ul class="navbar-nav mx-auto mb-2 mb-lg-0" style="margin-bottom: 0!important;">
          <li class="nav-item">
            <router-link to="/catalog" class="nav-link active navbar-text-color px-4" @click="handleNavigation" aria-current="page">Каталог</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/recipes" class="nav-link navbar-text-color px-4" @click="handleNavigation" >Рецепты</router-link>
          </li>
          <li class="nav-item">
            <router-link to="" class="nav-link navbar-text-color px-4" @click="handleNavigation" >Доставка</router-link>
          </li>
          <li class="nav-item">
            <router-link to="" class="nav-link navbar-text-color px-4" @click="handleNavigation" >Оплата</router-link>
          </li>
          <li class="nav-item">
            <router-link to="" class="nav-link navbar-text-color px-4" @click="handleNavigation" >О нас</router-link>
          </li>
        </ul>
        <ul class="mb-2 mb-lg-0 ps-0">
          <li class="nav-item d-flex align-items-center justify-content-center">
            <router-link to="" class="nav-link navbar-text-color">Профиль</router-link>
            <img src="/assets/Vector.svg" alt="Иконка профиля" class="ms-2 d-none d-lg-flex ">
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style>
.navbar-text-color{
  color: #F2F2F2FF!important;
}
.navbar-nav {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.nav-centered {
  width: 100%;
  justify-content: center;}
.fixed-navbar {
  position: fixed!important;
  top: 0!important;
  left: 0!important;
  width: 100%!important;
  max-width: 100%!important;
  z-index: 10!important; /* Устанавливаем z-index выше, чем у изображения */
}
</style>

<script>


// import store from "@/store";
// import { inject } from 'vue';

import { useRouter } from 'vue-router';
export default {
  name: "ClientHeader",
  components: {
  },
  setup(){
    const router = useRouter();

    const handleNavigation = () => {
      // Закрываем меню, если оно открыто
      if (document.getElementById('toggler_navbar').classList.contains('collapsed')) {
        return;
      }
      document.getElementById('toggler_navbar').click();
    };

    return {
      router,
      handleNavigation
    };
  },
  props: {
    // isAuth: {
    //   type: Boolean,
    //   default: false
    // }
  },

  mounted(){

  },

  methods: {

  },
}

</script>